// extracted by mini-css-extract-plugin
module.exports = {"item":"AdminProducts_item__1BoEq","editModal":"AdminProducts_editModal__10vdI","editor":"AdminProducts_editor__3Yb5a"};
    if(module.hot) {
      // 1686459238009
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  